import { BasicsClass } from "@/common/BasicsClass";
import { Util } from "@/common/util";

import { CommonApi } from "../common";

export class CompetitionBroadcastScreenOptionAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getCompetitionNineBallOption', {
      url: '/admin/nineBall/info',
      name: 'mine-ball-info',
      label: '赛事九球详情'
    }],

    // ['searchVenueList', {
    //   url: '/admin/coupons/shop/list',
    //   name: 'shop-list',
    //   label: '店铺列表',
    //   // hidden: true
    // }],

    ['setCompetitionNineBallOption', {
      url: '/admin/nineBall/submit',
      name: 'competition-nine-ball-option',
      label: '九球赛事配置',
      // hidden: true
    }],
    
  ])
  // 赛事九球详情
  public getCompetitionNineBallOption(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {

    console.log(params, "params");

    const apiUrls = this.apiUrls

    const url = apiUrls.get('getCompetitionNineBallOption').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 搜索店铺列表
  // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('searchVenueList').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 九球赛事配置
  public setCompetitionNineBallOption(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('setCompetitionNineBallOption').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
}
